import React, { useEffect } from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import Loadable from 'react-loadable';
import LoginRedirect from '../../DYHAC/app/modules/login/login-redirect';
import PrivateRoute from '../../../app/shared/auth/private-route';
import ErrorBoundaryRoutes from '../../../app/shared/error/error-boundary-routes';
import { AUTHORITIES } from '../app/config/constants';
import { Logout } from './modules/login/logout';
import Dashboard from '../../DYHAC/app/modules/dashboard/dashboard';
import UpcomingPage from './modules/dashboard/upcomingPage';
import FaqPage from './modules/dashboard/faq-page';
import TermsCondition from './modules/dashboard/terms-condition';
import PrivacyPolicy from './modules/dashboard/privacy-policy';
import PlanScreen from './modules/plan/plan';
import { REDIRECT_URL } from '../../../app/shared/util/url-utils';
import PageRoute from './modules/home/pageRoute';
import SignupRedirect from './modules/login/signupRedirect';
import { useAppSelector } from '../../../app/config/store';
import CaseQuestionaire from './modules/case-questionaire';
import CaseLawyer from './modules/case-questionaire/case-lawyer';
import CaseEvidence from './modules/case-questionaire/case-evidence';
import { CaseReview } from './entities/case-review/case-review';
import PageNotFound from './shared/layout/pageNotFound';

const loading = <div>loading ...</div>;

const Admin = Loadable({
  loader: () => import(/* webpackChunkName: "administration" */ '../../../app/modules/administration'),
  loading: () => loading,
});
const AppRoutes = () => {
  const location = useLocation();
  const hideLoaderPaths = ['/privacy-policy', '/terms-conditions', '/plan'];
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const shouldShowLoader = !isAuthenticated && !hideLoaderPaths.includes(location.pathname);
  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.setItem(REDIRECT_URL, location.pathname);
    }
  }, [isAuthenticated, location.pathname]);

  return (
    <div className="view-routes">
      {shouldShowLoader && <div className="conductor_loader"></div>}
      <ErrorBoundaryRoutes>
        {/* <Route
          path="/casereview"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <CaseReview />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/terms-conditions"
          element={
            // <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
            <TermsCondition />
            // </PrivateRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            // <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
            <PrivacyPolicy />
            // </PrivateRoute>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/plan/*"
          element={
            // <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
            <PlanScreen />
            // </PrivateRoute>
          }
        />
        <Route
          path="/case-help-resource"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <UpcomingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/step-1"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <CaseQuestionaire />
            </PrivateRoute>
          }
        />
        <Route
          path="/step-2"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <CaseLawyer />
            </PrivateRoute>
          }
        />
        <Route
          path="/evidence"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <CaseEvidence />
            </PrivateRoute>
          }
        />
        <Route
          path="/report"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <CaseReview />
            </PrivateRoute>
          }
        />
        <Route
          path="/case-faqs"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <FaqPage />
            </PrivateRoute>
          }
        />
        {/* <Route index element={<Home />} /> */}
        <Route path="logout" element={<Logout />} />
        <Route
          path="admin/*"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.ADMIN]}>
              <Admin />
            </PrivateRoute>
          }
        />
        <Route path="oauth2/authorization/oidc" element={<LoginRedirect />} />
        <Route path="/" element={<PageRoute />} />
        <Route path="signup" element={<SignupRedirect />} />

        <Route
          path="signin"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <ErrorBoundaryRoutes>
                <Route path="/">
                  <Route index element={<Navigate to="/oauth2/authorization/oidc" replace />} />
                </Route>
              </ErrorBoundaryRoutes>
            </PrivateRoute>
          }
        />

        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default AppRoutes;
